export default __webpack_public_path__ + "static/media/icon_arkadium.5f705f13.png";